import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { api } from "../utils/Api";
import { useHistory } from "react-router-dom";
import formatDate from "../utils/FormatDate";
import {
	Button,
	Checkbox,
	Col,
	Flex,
	Form,
	Image,
	Input,
	InputNumber,
	// Modal,
	notification,
	Row,
	Select,
	Tag,
	Typography,
} from "antd";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import {
	PlusCircleFilled,
	DeleteFilled,
	FilePdfFilled,
	NotificationFilled,
	FileImageFilled,
} from "@ant-design/icons";
import ModalBootstrap from "react-bootstrap/Modal";

const { Text } = Typography;

const optionsDate = {
	hour: "numeric",
	minute: "numeric",
	second: "numeric",
	hour12: true,
};

const LoadJob = ({ pcb, job }) => {
	const [loads, setLoads] = useState([]);
	const [loadSum, setLoadSum] = useState("");
	const [newLoad, setNewLoad] = useState("");
	let history = useHistory();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [loadingButton, setLoadingButton] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [optionsDrivers, setOptionsDrivers] = useState([]);
	const [loadingDriver, setLoadingDriver] = useState(true);
	const [optionsTrucks, setOptionsTrucks] = useState([]);
	const [loadingTruck, setLoadingTruck] = useState(true);
	const [disabledNotification, setDisabledNotification] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const evidenceRef = useRef(null);
	const [modalEvidenceOpen, setModalEvidenceOpen] = useState(false);
	const [isBalance, setIsBalance] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Load (YD3)",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Target",
			dataIndex: "target",
			key: "target",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Balance",
			dataIndex: "balance",
			key: "balance",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Is Balance?",
			dataIndex: "isBalance",
			key: "isBalance",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (value) => {
				let color = "default";
				switch (value) {
					case "In Plant":
						color = "blue";
						break;
					case "To Job":
						color = "gold";
						break;
					case "Arrived":
						color = "purple";
						break;
					case "Completed":
						color = "green";
						break;
					default:
						break;
				}
				return <Tag color={color}>{value}</Tag>;
			},
		},
		{
			title: "Difference",
			dataIndex: "difference",
			key: "difference",
			render: (value) => {
				return <Text type={value <= 0 ? "success" : "danger"}>{value}</Text>;
			},
		},
		{
			title: "Ticket",
			dataIndex: "deliveryTicket",
			key: "deliveryTicket",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Order Code",
			dataIndex: "orderCode",
			key: "orderCode",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Sequence",
			dataIndex: "sequence",
			key: "sequence",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Actions",
			dataIndex: "edit",
			width: 150,
			render: (_, record) => {
				const hyperlink = `http://ec2-3-85-198-38.compute-1.amazonaws.com/${record.id}`;
				return (
					<Row gutter={16}>
						<Button
							type="primary"
							href={hyperlink}
							target="_blank"
							icon={<FilePdfFilled twoToneColor={"white"} />}
							// onClick={() => history.push(`/e-ticket/${record.id}`)}
						/>
						&nbsp;
						{record.lateEvidenceUrl && (
							<Button
								type="primary"
								style={{ backgroundColor: "black" }}
								icon={<FileImageFilled twoToneColor={"white"} />}
								onClick={() => {
									evidenceRef.current = record.lateEvidenceUrl;
									setModalEvidenceOpen(true);
								}}
							/>
						)}
						&nbsp;
						<Button
							type="primary"
							danger
							icon={<DeleteFilled twoToneColor={"white"} />}
							disabled={
								!(
									localStorage.getItem("email") === "vm@57concrete.com" ||
									localStorage.getItem("email") === "rs@57concrete.com" ||
									localStorage.getItem("email") === "fc@57concrete.com" ||
									localStorage.getItem("email") === "jp@57concrete.com" ||
									localStorage.getItem("email") === "ec@57concrete.com" ||
									localStorage.getItem("email") === "pc@57concrete.com" ||
									localStorage.getItem("email") === "jc@57concrete.com" ||
									localStorage.getItem("email") === "fr@57concrete.com" ||
									localStorage.getItem("email") === "gg@57xgroup.com" ||
									localStorage.getItem("email") === "eliud@gmail.com"
								)
							}
							onClick={() => deleteLoad(record)}
						/>
					</Row>
				);
			},
		},
	];

	useEffect(() => {
		getInitialValues();
	}, []);

	const getInitialValues = async () => {
		await Promise.all([getDrivers(), getTrucks()]).then(() => {
			getLoadData();
			setLoading(false);
			setLoadingButton(false);
		});
	};

	const getDrivers = async () => {
		const url = api + "/driver/list/57Concrete/active";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			setOptionsDrivers([
				...data.map((driver) => {
					return {
						value: driver._id,
						simpleLabel: driver.name.toUpperCase(),
						label: (
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<span>{driver.name.toUpperCase()}</span>
								<Tag
									color={
										(driver.franchise || "57Concrete") === "57Concrete"
											? "blue"
											: driver.franchise === "Castle"
												? "green"
												: "cyan"
									}
								>
									{driver.franchise || "57Concrete"}
								</Tag>
							</div>
						),
					};
				}),
			]);
			setLoadingDriver(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTrucks = async () => {
		const url = api + "/truck/list/57Concrete/active";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			setOptionsTrucks([
				...data.map((truck) => {
					return {
						value: truck._id,
						simpleLabel: truck.number,
						label: (
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<span>{truck.number}</span>
								<Tag
									color={
										(truck.franchise || "57Concrete") === "57Concrete"
											? "blue"
											: truck.franchise === "Castle"
												? "green"
												: "cyan"
									}
								>
									{truck.franchise || "57Concrete"}
								</Tag>
							</div>
						),
					};
				}),
			]);
			setLoadingTruck(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getLoadData = async () => {
		const url = api + "/load/job/" + job._id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			setLoads([
				...data.map((item) => {
					let status = "In Plant";
					let time = 0;
					if (item.job.destinationTime) {
						time = parseInt(item.job.destinationTime.split(" ")[0]);
					} else if (item.job.destinationMinutes) {
						time = item.job.destinationMinutes;
					}

					let minutes = 0;
					if (item.toJobDate && item.toArriveDate) {
						let toJobDate = new Date(item.toJobDate);
						let toArriveDate = new Date(item.toArriveDate);
						var difference = toArriveDate.getTime() - toJobDate.getTime(); // This will give difference in milliseconds
						minutes = Math.round(difference / 60000);
					}

					let diff = time - minutes;
					if (item.statusTrip === "Stand By") {
						status = "In Plant";
					} else if (item.statusTrip === "Start Trip") {
						status = "To Job";
					} else if (item.statusTrip === "Arrive Trip") {
						status = "Arrived";
					} else if (
						item.statusTrip === "End Trip" ||
						item.statusTrip === "Back To Plant"
					) {
						status = "Completed";
					} else {
						status = "-";
					}
					return {
						id: item._id,
						key: item._id,
						driver: item.driver,
						orderCode: item.orderCode,
						date: new Intl.DateTimeFormat("en-US", optionsDate).format(
							new Date(item.date),
						),
						currentDate: item.date,
						yards: item.yards,
						deliveryTicket: item.deliveryTicket,
						sequence: item.sequence,
						truck: item.truckNumber,
						difference: diff,
						status: status,
						lateEvidenceUrl: item.lateEvidenceUrl,
						target: item.target || 0,
						balance: item.balance || 0,
						isBalance: item.isBalance || false,
					};
				}),
			]);
			form.resetFields();
			const suma = data
				.map((viaje) => viaje.yards)
				.reduce((acc, acum) => acc + acum, 0);
			setLoadSum(suma);
			setLoadingTable(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	// delete load
	const deleteLoad = async (load) => {
		setLoadingTable(true);
		const url = api + `/load/${load.id}`;
		const urlHistory = api + `/history`;
		const urlJob = api + `/job/${job._id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const bodyHistory = {
				date: new Date(),
				customer: job.customer._id,
				user: localStorage.getItem("userId"),
				type: "Load",
				yards: load.yards,
				number: load.deliveryTicket,
			};
			await axios.post(urlHistory, bodyHistory);
			await axios.delete(url);
			getLoadData();

			let jobBody = {
				loadYD3: loadSum,
			};

			if (load.isBalance) {
				jobBody.currentBalance = -load.balance;
			}

			const currentSum = parseFloat(localStorage.getItem("loadSum"));
			const newSum = currentSum - load.yards;
			const result = Math.round(newSum * 100) / 100;
			localStorage.setItem("loadSum", result);

			await axios.patch(urlJob, jobBody);
			openNotification("success", "Success", "Load deleted");
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	// Send SMS to company contact and foreman
	const sendSMS = async (values, phone) => {
		const url = api + "/smsmessagetxt";

		let accumYards = 0;
		let date1 = new Date().getTime();
		loads.map((itemLoad) => {
			let date2 = new Date(itemLoad.currentDate).getTime();
			if (date2 <= date1) {
				accumYards += itemLoad.yards;
			}
		});
		accumYards += values.yards;

		let msg = `Your order with ${values.yards} yards has been loaded. `;
		msg += `Ticket: ${values.deliveryTicket}. Driver: ${values.driver.label}. Cummulative Yards: ${accumYards}.`;

		if (values.truck.label !== "0") {
			msg += " Truck No. " + values.truck.label;
		}

		msg += " #57concrete";

		const smsBody = {
			phone,
			msg,
		};

		try {
			await axios.post(url, smsBody);
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", "Cannot send message");
			console.error(err.message);
			return null;
		}
	};

	// save new load
	const saveLoadData = async (values, sequenceNumber) => {
		setLoadingButton(true);
		const url = api + "/load";
		const urlJob = api + `/job/${job._id}`;
		const token = localStorage.getItem("token");
		const userId = localStorage.getItem("userId");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		const loadDate = new Date();

		let target = values.yards;

		if (values.isBalance) target = values.yards - values.balance;

		const carga = {
			yards: values.yards,
			driver: values.driver.label,
			driverId: values.driver.value,
			job: job._id,
			date: loadDate,
			deliveryTicket: values.deliveryTicket,
			orderCode: values.orderCode,
			truckNumber: values.truck.label,
			truck: values.truck.value,
			sequence: sequenceNumber,
			createdBy: userId,
			updatedBy: userId,
			franchise: job.franchise,
			commentsLoad: values.comments,
			target: target,
			balance: values.balance,
			isBalance: values.isBalance,
		};
		let currentBalance = 0;
		if (values.isBalance) currentBalance += values.balance;

		const currentSum = parseFloat(localStorage.getItem("loadSum"));
		setNewLoad(newLoad);
		const newSum = currentSum + parseFloat(newLoad);
		const result = Math.round(newSum * 100) / 100;

		localStorage.setItem("loadSum", result);

		try {
			await axios.post(url, carga);
			const jobLoad = {
				loadYD3: parseFloat(localStorage.getItem("loadSum")),
				currentBalance: currentBalance,
			};
			await axios.patch(urlJob, jobLoad);
			getLoadData();
			setLoadingButton(false);
			openNotification("success", "Success", "Load created");

			const text = `${values.driver.label}, Truck: ${
				values.truck.label
			}.\nTicket: ${values.deliveryTicket}.\nClient: ${
				job.customer.name
			}.\nShip Address: ${job.customerShipAddress}.
			\nSlump: ${job.slump}.\nLoad: ${values.yards} yards.\nSequence: ${
				loadSum + values.yards
			}.\nComments: ${values.comments || "N/A"}`;

			const driverId = values.driver.value;
			const type = "Assigned Load";
			await createNotification(text, driverId, type);
			setDisabledNotification(false);
		} catch (err) {
			openNotification("error", "Error", "Load cannot be created");

			setLoadingButton(false);
			console.error(err);
			return null;
		}
	};

	/*
        Send SMS messages only to registered phones
    */
	const sendMessages = (values) => {
		if (job.customer.contactPhone) {
			sendSMS(values, job.customer.contactPhone);
		}
		if (job.foremanPhone) {
			sendSMS(values, job.foremanPhone);
		}
		if (job.pmPhone) {
			sendSMS(values, job.pmPhone);
		}
		if (job.supervisorPhone) {
			sendSMS(values, job.supervisorPhone);
		}
		if (job.customer1) {
			sendSMS(job.customer1Phone, values);
		}
		if (job.customer2) {
			sendSMS(job.customer2Phone, values);
		}
	};

	// check sequence
	const checkSequence = async (values) => {
		setLoadingButton(true);
		const startDate = new Date();

		const url =
			api +
			`/loadsequence?startDate=${formatDate(startDate)}&sequence=${
				values.sequence
			}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url);

			if (data.loadId) {
				const body = {
					sequence: data.newSequence,
					updatedBy: localStorage.getItem("userId"),
				};
				updateLoad(data.loadId, body);
				saveLoadData(values, data.sequence);
				sendMessages(values);
			} else {
				saveLoadData(values, data.sequence);
				sendMessages(values);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			setLoadingButton(false);
			console.error(err.message);
			return null;
		}
	};

	// upload load sequence
	const updateLoad = async (loadId, body) => {
		const url = api + `/load/${loadId}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.patch(url, body);
		} catch (err) {
			openNotification("error", "Error", err.message);
			setLoadingButton(false);
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<CustomTable
				columns={columns}
				data={loads}
				isScroll={false}
				loading={loadingTable}
			/>
		);
	};

	const onFinish = () => {
		const values = form.getFieldsValue(true);
		checkSequence(values);
	};

	const filterOption = (input, option) =>
		(option?.simpleLabel ?? "").toLowerCase().includes(input.toLowerCase());

	const onClickSendNotification = async () => {
		const values = form.getFieldsValue();
		const { deliveryTicket, driver, truck, yards } = values;
		if (!deliveryTicket && !driver && !truck && !yards) {
			openNotification(
				"warning",
				"Warning",
				"Cannot send notification. Fill Driver, Truck, Load, and Delivery Ticket to proceed.",
			);
		} else {
			const text = `Next to Load: ${driver.label}, Truck: ${truck.label}.\n${
				job.plant.name
			}\nPlant: ${job.subplant || "N/A"}`;
			const driverId = values.driver.value;
			const type = "Preview Load";
			await createNotification(text, driverId, type);
			setDisabledNotification(true);
		}
	};

	const createNotification = async (message, driver, type) => {
		const url = api + `/notification/create`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.post(url, { message, driver, type });
			if (type === "Preview Load") {
				if (data.success) {
					openNotification(
						"success",
						"Success",
						"Notification sent successfully",
					);
				} else {
					openNotification("error", "Error", "Failed to send notification");
				}
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			setLoadingButton(false);
			console.error(err.message);
			return null;
		}
	};

	const onChangeIsBalance = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setIsBalance(true);
		} else {
			setIsBalance(false);
			form.setFieldsValue({
				balance: undefined,
			});
		}
	};

	const CustomForm = () => (
		<Form
			form={form}
			layout="vertical"
			onFinish={onFinish}
			style={{ marginTop: "20px" }}
			initialValues={{
				driver: undefined,
				truck: undefined,
				yards: undefined,
				deliveryTicket: undefined,
				orderCode: undefined,
				sequence: undefined,
				balance: undefined,
				isBalance: false,
			}}
		>
			<Row gutter={16}>
				<Col span={24} sm={12}>
					<Form.Item
						label="Driver"
						name="driver"
						rules={[
							{
								required: true,
								message: "Driver is required",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							dropdownStyle={{ zIndex: 2000 }}
							size="large"
							placeholder="Please select driver"
							options={optionsDrivers}
							loading={loadingDriver}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							optionLabelProp="simpleLabel"
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={12}>
					<Form.Item
						label="Truck"
						name="truck"
						rules={[
							{
								required: true,
								message: "Truck is required",
							},
						]}
					>
						<Select
							style={{
								width: "100%",
							}}
							dropdownStyle={{ zIndex: 2000 }}
							size="large"
							placeholder="Please select truck"
							options={optionsTrucks}
							loading={loadingTruck}
							optionFilterProp="children"
							filterOption={filterOption}
							showSearch
							labelInValue
							optionLabelProp="simpleLabel"
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={8}>
					<Form.Item
						label="Load"
						name="yards"
						rules={[
							{
								required: true,
								message: "Yards are required",
							},
						]}
					>
						<InputNumber
							step={0.1}
							size="large"
							placeholder="Enter yards"
							style={{ width: "100%" }}
						/>
					</Form.Item>
				</Col>
				<Col span={24} sm={4}>
					<Form.Item label="Balance" name="isBalance" valuePropName="checked">
						<Checkbox onChange={onChangeIsBalance}>Is Balance?</Checkbox>
					</Form.Item>
				</Col>
				{isBalance && (
					<Col span={24} sm={12}>
						<Form.Item
							label="Balance Load"
							name="balance"
							rules={[
								{
									required: true,
									message: "Balance is required",
								},
							]}
						>
							<InputNumber
								step={0.1}
								size="large"
								placeholder="Enter balance quantity"
								style={{ width: "100%" }}
							/>
						</Form.Item>
					</Col>
				)}
				<Col span={24} sm={12}>
					<Form.Item
						label="Delivery Ticket"
						name="deliveryTicket"
						rules={[
							{
								required: true,
								message: "Delivery Ticket is required",
							},
						]}
					>
						<Input size="large" placeholder="Enter delivery ticket" />
					</Form.Item>
				</Col>
				<Col span={24} sm={12}>
					<Form.Item
						label="Order Code"
						name="orderCode"
						rules={[
							{
								required: true,
								message: "Order code is required",
							},
						]}
					>
						<Input size="large" placeholder="Enter order code" />
					</Form.Item>
				</Col>
				<Col span={24} sm={12}>
					<Form.Item
						label="Sequence"
						name="sequence"
						rules={[
							{
								required: true,
								message: "Sequence is required",
							},
						]}
					>
						<InputNumber
							step={1}
							min={1}
							size="large"
							placeholder="Enter sequence"
							style={{ width: "100%" }}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item label="Comments" name="comments">
						<Input size="large" placeholder="Comments" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24} sm={12} md={8} lg={4}>
					<Button
						type="primary"
						htmlType="submit"
						loading={loadingButton}
						size="large"
						style={{
							width: "100%",
						}}
						icon={<PlusCircleFilled twoToneColor={"white"} />}
					>
						Add
					</Button>
				</Col>
				<Col span={24} sm={12} md={10} lg={6}>
					<Button
						type="default"
						htmlType="button"
						loading={loadingButton}
						size="large"
						style={{
							width: "100%",
						}}
						icon={<NotificationFilled twoToneColor={"white"} />}
						onClick={onClickSendNotification}
						disabled={disabledNotification}
					>
						Send Notification
					</Button>
				</Col>
			</Row>
		</Form>
	);

	const ModalEvidence = () => {
		return (
			<ModalBootstrap
				show={modalEvidenceOpen}
				animation={false}
				centered
				onHide={() => setModalEvidenceOpen(false)}
			>
				<ModalBootstrap.Header closeButton>
					<ModalBootstrap.Title>Late Evidence</ModalBootstrap.Title>
				</ModalBootstrap.Header>
				<ModalBootstrap.Body>
					{evidenceRef.current !== null && (
						<Image width={"100%"} src={evidenceRef.current} preview={false} />
					)}
				</ModalBootstrap.Body>
			</ModalBootstrap>
			// <Modal
			// 	title="Claim Comments"
			// 	open={modalEvidenceOpen}
			// 	onCancel={() => setModalEvidenceOpen(false)}
			// 	cancelButtonProps={{ style: { display: "none" } }}
			// 	okButtonProps={{ style: { display: "none" } }}
			// 	width={3000}
			// 	style={{ zIndex: 1000000000 }}
			// >
			// 	{evidenceRef.current !== null && (
			// 		<Image
			// 			width={200}
			// 			src={evidenceRef.current}
			// 			style={{ zIndex: 30000 }}
			// 		/>
			// 	)}
			// </Modal>
		);
	};

	return (
		<div>
			{contextHolder}
			<Flex vertical gap={"middle"}>
				<Text strong style={{ fontSize: "20px" }}>
					Load Total: {Math.round(loadSum * 100) / 100}
				</Text>
				<RenderTable />
				{loading ? <CustomSpinner /> : <CustomForm />}
				<ModalEvidence />
			</Flex>
		</div>
	);
};

export default LoadJob;
